import React from 'react';
import { Link, useNavigate, useParams, useLocation } from 'react-router-dom';
import { format } from 'date-fns';
import { getCompanySlug } from '../../../../client-experience/utils/companyAccess';
import { useStorefrontAuth } from '../../../auth/context/StorefrontAuthContext';
import '../../styles/StorefrontAppointmentCancel.css';

const parseAppointmentDate = (dateValue) => {
  if (!dateValue) return null;
  try {
    if (dateValue instanceof Date) return dateValue;
    if (typeof dateValue?.toDate === 'function') return dateValue.toDate();
    if (dateValue?.seconds) return new Date(dateValue.seconds * 1000);
    const parsed = new Date(dateValue);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  } catch {
    return null;
  }
};

const AppointmentCancelConfirmation = () => {
  const navigate = useNavigate();
  const { companyUrl: companyUrlParam } = useParams();
  const location = useLocation();
  const { companyData } = useStorefrontAuth();
  const appointmentData = location.state?.appointmentData;

  const companySlug = getCompanySlug(companyData) || companyUrlParam
    || (typeof window !== 'undefined' ? localStorage.getItem('clientPortalUrl') : '')
    || '';

  if (!appointmentData) {
    navigate(companySlug ? `/book/${companySlug}/account` : '/book');
    return null;
  }

  const when = parseAppointmentDate(appointmentData.dateTime);
  const formattedDate = when ? format(when, 'EEEE, MMMM d, yyyy') : '—';
  const formattedTime = when ? format(when, 'h:mm a') : '';

  return (
    <div className="sf-cancel-confirmation">
        <div className="sf-cancel-confirmation__icon" aria-hidden>
          <svg viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="1.75" />
            <path
              d="M8 8l8 8M16 8l-8 8"
              stroke="currentColor"
              strokeWidth="1.75"
              strokeLinecap="round"
            />
          </svg>
        </div>

        <h1 className="sf-cancel-confirmation__title">Appointment cancelled</h1>
        <p className="sf-cancel-confirmation__lead">
          Your appointment has been cancelled. You can book a new visit anytime from this storefront.
        </p>

        <div className="sf-cancel-confirmation__details">
          <p className="sf-cancel-confirmation__details-title">Cancellation details</p>
          <p className="sf-cancel-confirmation__when">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden>
              <rect
                x="3"
                y="4"
                width="18"
                height="18"
                rx="2"
                stroke="currentColor"
                strokeWidth="1.75"
              />
              <path d="M16 2v4M8 2v4M3 10h18" stroke="currentColor" strokeWidth="1.75" />
            </svg>
            <span>
              {formattedDate}
              {formattedTime ? ` at ${formattedTime}` : ''}
            </span>
          </p>

          {appointmentData.cancelReason ? (
            <div className="sf-cancel-confirmation__reason-block">
              <p className="sf-cancel-confirmation__reason-label">Reason</p>
              <p className="sf-cancel-confirmation__reason-text">{appointmentData.cancelReason}</p>
            </div>
          ) : null}
        </div>

        <Link
          to={companySlug ? `/book/${companySlug}/account` : '/book'}
          className="sf-cancel-confirmation__cta"
        >
          Back to your account
        </Link>
    </div>
  );
};

export default AppointmentCancelConfirmation;
